import { render } from "./github.vue?vue&type=template&id=251c312c&scoped=true"
import script from "./github.vue?vue&type=script&lang=js"
export * from "./github.vue?vue&type=script&lang=js"

import "./github.vue?vue&type=style&index=0&id=251c312c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251c312c"]])

export default __exports__